<template>
    <v-card variant="tonal" :border="true" class="text-center pa-3 elevation-2" :flat="true" :rounded="true">
        <v-btn color="black"
               :icon="true"
               size="large"
               variant="flat"
               :ripple="false"
               class="non-interactive"
               :style="{ border: '1px solid ' + (getColorCss(ability.type) || 'rgba(var(--v-border-color))') }"
        >
            <v-icon :icon="'ko:ability-' + ability.name.toLowerCase()"
                   :color="getColorCss(ability.type)"
                   size="30"
            />
        </v-btn>
        <div class="text-h6 mt-2">{{ quantity }}</div>
        <div class="currency-label text-medium-emphasis">{{ ability.name }}</div>
    </v-card>
</template>

<script setup>
    import {computed} from "vue";
    import {storeToRefs} from "pinia";
    import {useMainStore} from "@/store";
    import {useAbilityColors} from "@/composables/useAbilityColors";

    const props = defineProps({
        quantity: {
            type: [Number, String],
        },
        ability_id: {
            type: [Number, String],
        },
    });

    const store = useMainStore();
    const {references} = storeToRefs(store);
    const abilities = computed(() => references.value.data.design.ability);
    const ability = computed(() => {
        return abilities.value.find(a => String(a.id) === String(props.ability_id));
    });
    const {getColorCss} = useAbilityColors();
</script>

<style scoped>
    .non-interactive {
        pointer-events: none;
    }
    .currency-label {
        font-size: 0.65rem;
        overflow-wrap: normal;
        word-break: keep-all;
        white-space: nowrap;
    }
</style>
